import { ICommandBase } from '@/commands/interface/iCommandBase';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { TableCellInfo2 } from '@/model/document2/page/surface/design/layer/table/tableCellInfo2';
import { ArrayHelper } from '@/helper/arrayHelper';

// 表レイヤーのセル追加コマンド
export class AddTableCellCommand implements ICommandBase
{
    private layer! : TableLayer;
    // 方向
    // 0: 左に追加
    // 1: 上に追加
    // 2: 下に追加
    // 3: 右に追加
    private direction! : number;
    private doneCallback! : () => void;

    private row : number = 0;
    private column : number = 0;

    private addRow : number = -1;
    private addColumn : number = -1;

    private orgLayerWidth : number = 0;
    private orgLayerHeight : number = 0;

    private orgMap : Array<Array<TableCellInfo2>> = new Array();

    constructor(layer : TableLayer, row : number, column : number, direction : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.direction = direction;
        this.doneCallback = doneCallback;

        this.row = row;
        this.column = column;

        this.orgLayerWidth = layer.width;
        this.orgLayerHeight = layer.height;

        this.orgMap = this.cloneCellInfoMap();

        // 追加行・列番号
        if(direction == 0)
        {
            this.addColumn = column;
        }
        else if(direction == 1)
        {
            this.addRow = row;
        }
        else if(direction == 2)
        {
            this.addColumn = column + 1;
        }
        else if(direction == 3)
        {
            this.addRow = row + 1;
        }
    }

    private cloneCellInfoMap()
    {
        var array = new Array();

        for(var r = 0; r < this.layer.row; ++r)
        {
            array.push(new Array());
            for(var c = 0; c < this.layer.column; ++c)
            {
                var info = this.layer.getCellInfo(r, c);
                array[r].push(info.clone());
            }
        }

        return array;
    }

    public do() : void
    {
        this.doCore();
        
        this.doneCallback();
    }

    public undo() : void
    {
        // レイヤー長さ・高さ復帰
        this.layer.width = this.orgLayerWidth;
        this.layer.height = this.orgLayerHeight;
        // セル情報復帰
        this.layer.cellInfoMap = this.orgMap;

        this.doneCallback();
    }

    public redo() : void
    {
        this.doCore();
        
        this.doneCallback();
    }

    private doCore()
    {
        var orgCellInfo = this.layer.getCellInfo(this.row, this.column);
        // 列の幅(mm)
        var orgCellWidth = orgCellInfo.cellWidthNormalized * this.layer.width / 100;
        // この高さ(mm)
        var orgCellHeight = orgCellInfo.cellHeightNormalized * this.layer.height / 100;

        if(this.addColumn >= 0)
        {
            // 列追加
            // 新しいレイヤー幅
            var newLayerWidth = this.layer.width + orgCellWidth;

            // まずすべての行に対して列を追加する
            for(var r = 0; r < this.layer.row; ++r)
            {
                var newInfo = new TableCellInfo2();
                newInfo.cellHeightNormalized = this.layer.getCellInfo(r, this.column).cellHeightNormalized;
                this.layer.cellInfoMap[r].splice(this.addColumn, 0, newInfo);
            }
            
            // 幅の値更新を行う
            for(var r = 0; r < this.layer.row; ++r)
            {
                for(var c = 0; c < this.layer.column; ++c)
                {
                    var info = this.layer.getCellInfo(r, c).clone();
                    var cellWidth = c == this.addColumn ? orgCellWidth : info.cellWidthNormalized * this.layer.width / 100;
                    info.cellWidthNormalized = cellWidth / newLayerWidth * 100;
                    this.layer.setCellInfo(r, c, info);
                }
            }
            
            // レイヤー幅更新
            this.layer.width = newLayerWidth;

            if(this.direction == 0 && this.layer.currentColumn >= 0)
            {
                // 左へ追加した場合、カレント維持のため右へ選択移動
                this.layer.currentColumn++;
            }
        }

        if(this.addRow >= 0)
        {
            // 行追加
            // 新しいレイヤー高さ
            var newLayerHeight = this.layer.height + orgCellHeight;

            // まず行を追加する
            var newRow = new Array();
            for(var c = 0; c < this.layer.column; ++c)
            {
                var newInfo = new TableCellInfo2();
                newInfo.cellWidthNormalized = this.layer.getCellInfo(this.row, c).cellWidthNormalized;
                newRow.push(newInfo);
            }
            this.layer.cellInfoMap.splice(this.addRow, 0, newRow);
            
            // 高さの値更新を行う
            for(var r = 0; r < this.layer.row; ++r)
            {
                for(var c = 0; c < this.layer.column; ++c)
                {
                    var info = this.layer.getCellInfo(r, c).clone();
                    var cellHeight = r == this.addRow ? orgCellHeight : info.cellHeightNormalized * this.layer.height / 100;
                    info.cellHeightNormalized = cellHeight / newLayerHeight * 100;
                    this.layer.setCellInfo(r, c, info);
                }
            }
            
            // レイヤー高さ更新
            this.layer.height = newLayerHeight;

            if(this.direction == 1 && this.layer.currentRow >= 0)
            {
                // 上へ追加した場合、カレント維持のため下へ選択移動
                this.layer.currentRow++;
            }
        }
    }
}